<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Repositories from '@/repositories';
const OrdersRepository = Repositories.get('orders');
const OrderItemsRepository = Repositories.get('orderitems');
import ErrorView from '@/router/views/utility/error';
import ReceptionsList from '@/components/widgets/receptions/list';
import dateMixin from '@/mixins/dateMixin';
import Messages from '@/components/widgets/order-messages/list';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/fr';
import OrderReceptionModal from '../shared/modals/order-reception.vue';
import ItemDataModal from '../shared/modals/item-data.vue';
import MultipleItems from '@/components/widgets/popovers/multiple-items';

/**
 * Dashboard Component
 */
export default {
  props: {
    receptionIdPublic: String,
  },
  mixins: [dateMixin],
  components: {
    Loading,
    Messages,
    ErrorView,
    ReceptionsList,
    OrderReceptionModal,
    ItemDataModal,
    DatePicker,
    MultipleItems,
  },
  data() {
    return {
      isLoading: false,
      inReceiving: false,
      receiveAll: false,
      order: null,
      currentDate: new Date(),
      lastReceptionId: '',
      damagedQty: 0,
      dataType: '',
      item: null,
      orderItemsList: [],
      metadataEdition: {
        isEditingExternalNumber: false,
        isEditingReceptionDate: false,
        isLoadingExternalNumber: false,
        isLoadingReceptionDate: false,
        isErrorExternalNumber: false,
        isErrorReceptionDate: false,
      },
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.orderItemsList = [];
      this.isLoading = true;
      let promise1 = OrdersRepository.get(this.receptionIdPublic).then(
        (response) => {
          this.order = response.data;
        }
      );
      let promise2 = OrderItemsRepository.customREST
        .getByOrderWithWorkOrderItemOrderItems(this.receptionIdPublic)
        .then((response) => {
          this.orderItemsList = response.data.map((x) => {
            return {
              ...x,
              isReceived: false,
              toReceive:
                x.totalQuantity - x.receivedQuantity > 0
                  ? x.totalQuantity - x.receivedQuantity
                  : 0,
            };
          });
        });

      Promise.all([promise1, promise2])
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.$toast.errorToast(this.$t('errors.errorLoading'));
        });
    },
    toggleAll() {
      this.orderItemsList.map((x) => {
        x.isReceived = this.receiveAll;
      });
    },
    toggleReceiveItem(itemIdPublic) {
      let foundIndex = this.orderItemsList.findIndex(
        (x) => x.idPublic == itemIdPublic
      );

      if (foundIndex >= 0) {
        let foundItem = this.orderItemsList[foundIndex];
        this.orderItemsList = [
          ...this.orderItemsList.slice(0, foundIndex),
          { ...foundItem, isReceived: !foundItem.isReceived },
          ...this.orderItemsList.slice(foundIndex + 1),
        ];
      }
    },
    receptionAdded(reception) {
      this.lastReceptionId = reception.idPublic;
      this.inReceiving = false;

      this.loadData();
    },
    addReception() {
      this.$bvModal.show('order-reception-modal');
    },
    openItemDataModal(dataType, item) {
      if (this.inReceiving) {
        this.dataType = dataType;
        this.item = this.orderItemsList.find(
          (x) => x.idPublic == item.idPublic
        );
        this.$nextTick(() => {
          this.$bvModal.show('item-data');
        });
      }
    },
    startEditing(field) {
      this.order[`is${field}UpdatedExternal`] = true;
      this.metadataEdition[`isEditing${field}`] = true;
      this.$nextTick(() => {
        const editInput = this.$refs[`edit${field}Input`];
        editInput.focus();
      });
    },
    async save(field) {
      if (
        !this.metadataEdition.isLoadingExternalNumber &&
        !this.metadataEdition.isLoadingReceptionDate
      ) {
        this.metadataEdition[`isLoading${field}`] = true;
        this.metadataEdition[`isError${field}`] = false;

        await this.$nextTick();

        try {
          await OrdersRepository.update(this.order, this.order.idPublic);

          this.metadataEdition[`isEditing${field}`] = false;
        } catch (error) {
          this.metadataEdition[`error${field}`] = true;
          this.$toast.errorToast(this.$t('errors.errorLoading'));
        }

        this.metadataEdition[`isLoading${field}`] = false;
      }
    },
    async cancel(field) {
      await this.$nextTick();

      if (this.metadataEdition[`isLoading${field}`] == false) {
        this.metadataEdition[`isEditing${field}`] = false;
      }
    },
    sendEmail() {
      window.open(this.mailToString, '_blank');
    },
  },
  computed: {
    orderItemsListComputed() {
      if (this.orderItemsList != null) {
        return this.orderItemsList
          .flatMap((x) => {
            let returnValue = {
              ...x,
              subItem: false,
              arrayKey: x.idPublic,
              workOrderNames: [],
            };

            returnValue.orderedValue = x.totalUnits;

            if (
              x.itemSupplierOrderUnitQuantity > 0 &&
              x.itemSupplierOrderUnitQuantity != 1
            ) {
              returnValue.orderedValue +=
                ' (' + x.totalUnits * x.itemSupplierOrderUnitQuantity + ')';
            }

            if (x.editedItemCode) {
              returnValue.gridItemCode = x.editedItemCode;
            } else if (x.itemSupplierCode) {
              returnValue.gridItemCode = x.itemSupplierCode;
            } else {
              returnValue.gridItemCode = x.itemCode;
            }

            if (x.editedItemName) {
              returnValue.gridItemName = x.editedItemName;
            } else if (x.itemSupplierName) {
              returnValue.gridItemName = x.itemSupplierName;
            } else {
              returnValue.gridItemName = x.itemName;
            }

            if (x.workOrderItemOrderItems == null) {
              return returnValue;
            } else if (
              this.splitItemsByWorkOrder &&
              x.workOrderItemOrderItems.length > 1
            ) {
              let returnArray = [];
              let totalQuantity = x.totalQuantity;
              let reservedQuantity = x.reservedQuantity;
              let receivedQuantity = x.receivedQuantity;
              let receivedReservedQuantity = x.receivedReservedQuantity;

              for (let woioi of x.workOrderItemOrderItems) {
                totalQuantity -= woioi.totalQuantity;
                reservedQuantity -= woioi.totalQuantity;
                receivedQuantity -= woioi.reservedQuantity;
                receivedReservedQuantity -= woioi.reservedQuantity;

                returnArray.push({
                  ...x,
                  subItem: true,
                  arrayKey: x.idPublic + '-' + woioi.idPublic,
                  totalQuantity: woioi.totalQuantity,
                  reservedQuantity: woioi.totalQuantity,
                  receivedQuantity: woioi.reservedQuantity,
                  receivedReservedQuantity: woioi.reservedQuantity,
                  workOrderNames: [woioi.workOrderName],
                });
              }

              returnValue.totalQuantity = totalQuantity;
              returnValue.reservedQuantity = reservedQuantity;
              returnValue.receivedQuantity = receivedQuantity;
              returnValue.receivedReservedQuantity = receivedReservedQuantity;
              returnArray.unshift(returnValue);

              return returnArray;
            } else {
              let workOrderNames = [
                ...new Set(
                  x.workOrderItemOrderItems.map((item) => item.workOrderName)
                ),
              ];

              returnValue.workOrderNames = workOrderNames;
              return returnValue;
            }
          })
          .map((x) => {
            let receptionStatus = 'not-received';

            let receivedQuantity = x.receivedQuantity;

            if (receivedQuantity >= x.totalQuantity) {
              receptionStatus = 'received';
            } else if (receivedQuantity > 0) {
              receptionStatus = 'in-reception';
            }

            return {
              ...x,
              receptionStatus,
            };
          });
      }

      return [];
    },
    fieldsComputed() {
      return [
        {
          key: 'itemCode',
          label: this.$t('general.code'),
          class: 'table-row-relative',
        },
        {
          key: 'itemName',
          label: this.$t('items.item'),
          class: 'table-row-expandable',
        },
        {
          key: 'workOrderName',
          label: this.$t('workOrders.workOrders'),
          class: 'table-row-relative',
        },
        {
          key: 'status',
          label: this.$t('general.status'),
          class: 'table-row-relative',
        },
        {
          key: 'totalUnits',
          label: this.$t('receptions.orderedQty'),
          class: ['table-row-relative', 'status-width'],
        },
        {
          key: 'received',
          label: this.$t('items.received'),
          class: 'table-row-relative',
        },
        {
          key: 'damagedQty',
          label: this.$t('receptions.damagedQty'),
          class: 'table-row-relative',
        },
        {
          key: 'allocation',
          label: this.$t('general.allocation'),
          class: 'table-row-relative',
        },
        {
          key: 'total',
          label: this.$t('items.total'),
          class: 'table-row-relative',
        },
      ];
    },
    externalLink() {
      return (
        process.env.VUE_APP_REDIRECT_URL +
        'externals/' +
        this.order.supplierLanguage +
        '/orders/' +
        this.$store.state.user.config.organisationCode +
        '/' +
        this.order.idPublic
      );
    },
    mailToString() {
      return `mailto:${this.order.supplierEmail}?subject=${this.$t(
        'orders.order'
      )} ${
        this.order.externalNumber != null &&
        this.order.externalNumber.length > 0
          ? this.order.externalNumber
          : this.order.number
      }&body=${this.externalLink}`;
    },
    splitItemsByWorkOrder() {
      return this.$store.state.cache.ordersConfig.splitItemsByWorkOrder;
    },
  },
};
</script>

<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#f1b44c"
      :width="70"
      :height="70"
      loader="dots"
      :is-full-page="false"
    >
    </loading>

    <div v-if="order != null">
      <b-container fluid>
        <b-row>
          <b-col cols="8">
            <h1 class="mb-0">{{ order.number }}</h1>
            <div class="text-muted mb-3" style="font-size: 1.2em">
              {{ order.supplierName }}

              <i
                class="bx bxs-envelope"
                style="
                  font-size: 1.2em;
                  color: #bbb;
                  vertical-align: bottom;
                  cursor: pointer;
                "
                @click="sendEmail"
              >
              </i>
            </div>

            <div
              style="
                display: flex;
                height: 40px;
                align-items: center;
                max-width: 300px;
              "
              @keydown.escape.prevent.stop="cancel('ReceptionDate')"
            >
              <h3
                v-if="metadataEdition.isEditingReceptionDate == false"
                style="white-space: nowrap; margin-bottom: 0"
              >
                <span v-if="order.receptionDate == null">
                  {{ $t('orders.noReceptionDate') }}
                </span>
                <span
                  v-else-if="new Date(order.receptionDate) < currentDate"
                  class="mb-0 text-danger"
                >
                  {{ formatDate(order.receptionDate) }}
                  <i class="fas fa-exclamation-triangle text-danger m-auto" />
                </span>
                <span v-else class="mb-0">
                  {{ formatDate(order.receptionDate) }}
                </span>
              </h3>
              <date-picker
                v-else
                ref="editReceptionDateInput"
                v-model="order.receptionDate"
                :first-day-of-week="1"
                format="YYYY-MM-DD"
                value-type="format"
                @input="save('ReceptionDate')"
                style="font-size: 1.1em"
                :lang="$i18n.locale"
              >
              </date-picker>
              <div v-if="metadataEdition.isEditingExternalNumber == false">
                <i
                  v-if="metadataEdition.isLoadingReceptionDate"
                  id="popover-button"
                  class="fas fa-spinner fa-spin text-warning ml-3 mr-2"
                  @click="save('ReceptionDate')"
                  style="font-size: 1.5em"
                ></i>
                <i
                  v-else-if="metadataEdition.isErrorReceptionDate"
                  @click="save('ExternalNumber')"
                  class="fas fa-exclamation text-danger pl-3 pr-2"
                  style="cursor: pointer; font-size: 1.5em"
                ></i>
                <i
                  v-else-if="metadataEdition.isEditingReceptionDate"
                  id="popover-button"
                  @click="save('ReceptionDate')"
                  class="fas fa-check text-success pl-3 pr-2"
                  style="cursor: pointer; font-size: 1.5em"
                ></i>
                <i
                  v-else
                  id="popover-button"
                  class="fas fa-pencil-alt text-primary pl-2 pr-2"
                  @click="startEditing('ReceptionDate')"
                  style="cursor: pointer; font-size: 1.2em"
                ></i>
              </div>
            </div>

            <div class="text-muted mb-3" style="font-size: 1.2em">
              {{ $t('orders.receptionDate') }}
            </div>
          </b-col>
          <b-col v-if="order.isClosed == false" cols="4">
            <div class="text-right mt-2">
              <b-button
                v-if="inReceiving"
                variant="primary"
                class="mr-2"
                @click="addReception"
                >{{ this.$t('receptions.submit') }}</b-button
              >
              <b-form-checkbox
                v-model="inReceiving"
                name="check-button"
                button
                :button-variant="inReceiving ? 'warning' : 'primary'"
              >
                <b>{{
                  inReceiving
                    ? this.$t('receptions.inReception')
                    : this.$t('receptions.reception')
                }}</b>
              </b-form-checkbox>
            </div>
          </b-col>
        </b-row>
        <div>
          <b-form-checkbox
            v-model="receiveAll"
            @change="toggleAll()"
            size="lg"
            class="mb-3"
            v-if="inReceiving"
          >
            {{ this.$t('receptions.receiveAll') }}
          </b-form-checkbox>
        </div>

        <b-row>
          <b-col xl="9" lg="12">
            <b-table
              id="management-table"
              :items="orderItemsListComputed"
              :fields="fieldsComputed"
              head-variant="light"
              hover
            >
              <template #cell(itemCode)="data">
                {{ data.item.gridItemCode }}
              </template>
              <template #cell(itemName)="data">
                {{ data.item.gridItemName }}
              </template>
              <template #cell(workOrderName)="data">
                <MultipleItems
                  :list="data.item.workOrderNames"
                  :uniqueId="data.item.arrayKey"
                />
              </template>

              <template #cell(totalUnits)="data">
                {{ data.item.orderedValue }}
              </template>

              <template #cell(status)="data">
                <span
                  v-if="data.item.receptionStatus == 'received'"
                  class="badge badge-success badge-pill"
                  style="font-size: 1em"
                >
                  {{ $t('receptions.received') }}
                </span>
                <span
                  v-else-if="data.item.receptionStatus == 'in-reception'"
                  class="badge badge-warning badge-pill"
                  style="font-size: 1em"
                >
                  {{ $t('receptions.inReception') }}
                </span>
                <span
                  v-else
                  class="badge badge-danger badge-pill"
                  style="font-size: 1em"
                >
                  {{ $t('receptions.notReceived') }}
                </span>
              </template>

              <template #cell(received)="data">
                <template v-if="!data.item.subItem">
                  <b-row class="justify-content-md-center">
                    <div style="min-width: 140px">
                      <b-button
                        v-if="inReceiving"
                        :variant="
                          data.item.isReceived
                            ? 'badge badge-success'
                            : 'primary'
                        "
                        size="sm"
                        class="m-0"
                      >
                        <span
                          @click="openItemDataModal('received', data.item)"
                          class="mr-2"
                        >
                          <i v-if="inReceiving" class="fas fa-edit" />
                        </span>
                        <b @click="toggleReceiveItem(data.item.idPublic)">{{
                          $t('receptions.received')
                        }}</b>
                      </b-button>
                      <b-button v-else disabled size="sm" class="m-0">
                        <b>{{ $t('receptions.received') }}</b>
                      </b-button>
                    </div>
                  </b-row>
                </template>
              </template>

              <template #cell(damagedQty)="data">
                <template v-if="!data.item.subItem">
                  <span @click="openItemDataModal('damaged', data.item)">
                    {{ data.item.damagedQuantity }}
                    <i v-if="inReceiving" class="fas fa-edit ml-2" />
                  </span>
                </template>
              </template>

              <template #cell(allocation)="data">
                <template v-if="!data.item.subItem">
                  <span
                    v-if="data.item.allocationName != null"
                    @click="openItemDataModal('allocation', data.item)"
                  >
                    {{ data.item.allocationName }}
                    <i v-if="inReceiving" class="fas fa-edit ml-2" />
                  </span>
                  <span
                    v-else
                    @click="openItemDataModal('allocation', data.item)"
                  >
                    none
                    <i v-if="inReceiving" class="fas fa-edit ml-2" />
                  </span>
                </template>
              </template>

              <template #cell(total)="data">
                <span v-if="data.item.isReceived">
                  {{ +data.item.receivedQuantity + +data.item.toReceive }} /
                  {{ data.item.totalQuantity }}
                </span>
                <span v-else>
                  {{ data.item.receivedQuantity }} /
                  {{ data.item.totalQuantity }}
                </span>
              </template>
            </b-table>
          </b-col>

          <b-col xl="3" lg="12">
            <ReceptionsList
              :orderIdPublic="receptionIdPublic"
              :key="lastReceptionId"
            />
            <Messages
              :orderIdPublic="receptionIdPublic"
              :userIdPublic="$store.state.user.config.idPublic"
              :internalView="true"
            />
          </b-col>
        </b-row>
      </b-container>

      <OrderReceptionModal
        :orderIdPublic="receptionIdPublic"
        :orderItems="this.orderItemsList"
        @reception-added="receptionAdded"
      />
      <ItemDataModal :dataType="dataType" :itemData="item" />
    </div>
    <ErrorView
      :message="$t('orders.orderNotFound')"
      v-if="order == null && isLoading == false"
    />
  </div>
</template>

<style scoped>
.status-width {
  min-width: 300px !important;
  font-weight: light;
}
</style>
